import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import { generateDocumentSelectionModeName } from '../modes';
import { convertHexToRGBA } from '@utils/usefulFuncs';

const DocumentSelectionModesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
const DocumentSelectionModeWrapper = styled.div`
  padding: 8px 24px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.themeColors.background};
  // border: 1px solid ${({ theme }) => theme.themeColors.text};
  cursor: pointer;
  font-weight: bold;

  &.active {
    background-color: ${({ theme }) => theme.themeColors.text} !important;
    color: ${({ theme }) => theme.themeColors.componentNoOpacity} !important;

    * {
      color: ${({ theme }) => theme.themeColors.componentNoOpacity} !important;
    }
  }
  &:hover {
    background-color: ${({ theme }) => convertHexToRGBA(theme.themeColors.text, 0.6)};
    color: ${({ theme }) => theme.themeColors.componentNoOpacity} !important;

    * {
      color: ${({ theme }) => theme.themeColors.componentNoOpacity} !important;
    }
  }

  * {
    text-transform: uppercase;
  }
`;

export const ModeSelectBar = ({ modes, activeMode, onModeChange }) => {
  if (modes.length === 1) {
    return null;
  }

  return (
    <DocumentSelectionModesWrapper>
      {modes.map((mode) => (
        <DocumentSelectionModeWrapper
          onClick={() => onModeChange(mode)}
          active={activeMode === mode}
          className={activeMode === mode ? 'active' : ''}
        >
          <Body5>{generateDocumentSelectionModeName(mode)}</Body5>
        </DocumentSelectionModeWrapper>
      ))}
    </DocumentSelectionModesWrapper>
  );
};
